module.exports = __webpack_public_path__ + "img/yhpsqy.8d084844.png";